import { useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function usePatientMatches({ documentKey }: { documentKey: string }) {
  return useSuspenseQuery({
    ...apiClient.getDocumentPatientMatchesDocumentsKeyPatientMatchesGetOptions({
      path: { key: documentKey },
    }),
  })
}
